import IKenoDraw from "../interfaces/IKenoDraw";
import ITicket from "../interfaces/ITicket";

/**
 * Look up the list of numbers that were drawn for a ticket's draw.
 * - If it's the current draw, use the provided numbers as there might be visual reasons to exclude some
 * - If it's a past draw that can be looked up, use those numbers
 * - Otherwise, empty list
 *
 * @param ticket the ticket being looked up for numbers
 * @param currentDraw the current draw occurring
 * @param providedDrawnNumbers array of numbers, for animation/visual purposes
 * @param pastDraws dictionary of past draws to look up old tickets
 */
export default function getTicketDrawnNumbers(
    ticket: ITicket,
    currentDraw: IKenoDraw,
    providedDrawnNumbers: number[],
    pastDraws: { [key: string]: IKenoDraw | undefined },
): number[] {
    // Handle ticket being incomplete, empty list as we can't match the draw.
    if (!ticket.event) {
        return [];
    }

    const ticketDrawId = ticket.event.externalId;

    // Current draw, which uses the provided numbers-- as there could be a different set to show than past ones.
    if (ticketDrawId === currentDraw.id) {
        return providedDrawnNumbers;
    }

    // Old draw, show the cached numbers available.
    const pastDraw = pastDraws[ticketDrawId];
    if (!pastDraw) {
        return [];
    }

    // Numbers not yet drawn, return an empty list.
    if (!pastDraw.results || !pastDraw.results.main) {
        return [];
    }

    // Primary numbers drawn, this list may be empty, but it's at least structurally valid.
    return pastDraw.results.main[0];
}



// WEBPACK FOOTER //
// ./src/utils/getTicketDrawnNumbers.ts